import * as gridlines from "../operations/hide_gridlines";

export function hideGridlines(state, page){
	gridlines.hideGridlines(this, state, page);
}